import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import { whiteboardControllerForEditor } from '../EmbeddedWhiteboardControllersPluginFactory';

class ToolOpenWhiteboard extends Tool {
  static toolName = 'View whiteboard';
  static iconClass = 'fa-solid fa-up-right-and-down-left-from-center';

  static available({ controller }: ToolArgsWithController): boolean {
    return controller.ahaEditor.hasPlugin(
      'EmbeddedWhiteboardControllersPlugin'
    );
  }

  static action({ controller, element }: ToolArgsWithController): void {
    const whiteboardController = whiteboardControllerForEditor(
      controller.ahaEditor,
      element
    );

    if (whiteboardController) {
      whiteboardController.router.navigate(
        whiteboardController.getDisplayModeUrl('fullscreen')
      );
    }
  }
}

export default ToolOpenWhiteboard;
